/*********************************************************************************************
* Initialize the sticky CTA behavior.
* 
*/
function initializeStickyCTA() {
	const classicCTA = document.querySelector('[data-cta]');
	const stickyCTA = document.querySelector('[data-sticky-cta]');

	if (!classicCTA || !stickyCTA) return;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			// Si une modale "subscribe" est ouverte (quick add), on force le sticky CTA à rester inactif
			// (sinon l'IntersectionObserver peut le remettre en .active automatiquement).
			if (document.body && document.body.classList && document.body.classList.contains('mm-subscription-modal-open')) {
				stickyCTA.classList.remove('active');
				updateChatButtonPosition(false);
				return;
			}

			// Affiche le sticky CTA seulement si le CTA de base est hors de la vue
			// et positionné au-dessus de la fenêtre (scroll vers le bas).
			const isAboveViewport = entry.boundingClientRect.bottom < 0;
			const shouldBeActive = !entry.isIntersecting && isAboveViewport;
			stickyCTA.classList.toggle('active', shouldBeActive);
			updateChatButtonPosition(shouldBeActive);
		});
	}, { 
		root: null, 
		threshold: 0, // Déclenche dès que l'élément entre ou sort de la vue
	});

	observer.observe(classicCTA);

	// Observer les changements de classe externes éventuels
	const classObserver = new MutationObserver(function () {
		const suppressed = document.body && document.body.classList && document.body.classList.contains('mm-subscription-modal-open');
		updateChatButtonPosition(!suppressed && stickyCTA.classList.contains('active'));
	});
	classObserver.observe(stickyCTA, { attributes: true, attributeFilter: ['class'] });

	// Etat initial
	const suppressed = document.body && document.body.classList && document.body.classList.contains('mm-subscription-modal-open');
	updateChatButtonPosition(!suppressed && stickyCTA.classList.contains('active'));

	// Ajuster sur redimensionnement d'écran
	window.addEventListener('resize', function(){
		const suppressed = document.body && document.body.classList && document.body.classList.contains('mm-subscription-modal-open');
		updateChatButtonPosition(!suppressed && stickyCTA.classList.contains('active'));
	});
}


// Cache pour les pages de variants déjà chargées
const variantHtmlCache = {};

function getReloadTargets() {
    return Array.from(document.querySelectorAll('.mm-reload[data-mm-reload-key]')).filter(el => !el.closest('.mm-product-card-2-add-to-cart'));
}

function getReloadSectionIds() {
    const ids = [];
    getReloadTargets().forEach(el => {
        const section = el.closest('.shopify-section');
        const sectionId = section ? section.id.replace('shopify-section-', '') : '';
        if (sectionId && !ids.includes(sectionId)) ids.push(sectionId);
    });
    return ids.slice(0, 5);
}

function fetchVariantSections(variantUrl) {
    if (variantHtmlCache[variantUrl]) return variantHtmlCache[variantUrl];

    const sectionIds = getReloadSectionIds();
    const url = new URL(variantUrl, window.location.origin);
    url.searchParams.set('sections', sectionIds.join(','));

    variantHtmlCache[variantUrl] = fetch(url.toString())
        .then(response => {
            if (!response.ok) throw new Error('HTTP ' + response.status);
            return response.json();
        })
        .then(sections => {
            const parser = new DOMParser();
            const docs = {};
            Object.keys(sections).forEach(sectionId => {
                if (sections[sectionId]) docs[sectionId] = parser.parseFromString(sections[sectionId], 'text/html');
            });
            return docs;
        })
        .catch(error => {
            delete variantHtmlCache[variantUrl];
            throw error;
        });

    return variantHtmlCache[variantUrl];
}

function handleVariantSelection(variantElement) {
    const variantUrl = variantElement.getAttribute('data-variant-url');
    if (!variantUrl) return;

    // Gérer la classe 'active' pour synchroniser les deux sélecteurs (principal et sticky)
    const allVariantItems = document.querySelectorAll('.mm-product-form-variants-item, .mm-product-variant-selector-item');
    allVariantItems.forEach(item => {
        const isSelected = item.getAttribute('data-variant-url') === variantUrl;
        item.classList.toggle('active', isSelected);
    });

    window.history.replaceState({}, '', variantUrl);

    function updateReloadElements(docs) {
        // On utilise les data-mm-reload-key pour mettre à jour les blocs .mm-reload de chaque section rechargée
        // (y compris ceux en dehors de la section produit principale, comme la routine).
        const destinationElements = getReloadTargets();

        if (!destinationElements.length) return;

        const currentSubscriptionRadio = document.querySelector('input[name="purchase_option"][value="abonnement"]');
        const keepSubscription = currentSubscriptionRadio ? currentSubscriptionRadio.checked : null;

        destinationElements.forEach(dest => {
            if (!dest.isConnected) return;

            const reloadKey = dest.getAttribute('data-mm-reload-key');
            const section = dest.closest('.shopify-section');
            const doc = section ? docs[section.id.replace('shopify-section-', '')] : null;
            if (!reloadKey || !doc) return;

            const source = Array.from(doc.querySelectorAll('.mm-reload[data-mm-reload-key]')).find(src => src.getAttribute('data-mm-reload-key') === reloadKey && !src.closest('.mm-product-card-2-add-to-cart'));
            if (!source) return;

            // Si le sticky CTA était ouvert, on mémorise son état pour le réappliquer
            const wasStickyCTA = dest.matches('[data-sticky-cta]');
            const wasStickyActive = wasStickyCTA && dest.classList.contains('active');

            dest.outerHTML = source.outerHTML;

            // Réappliquer la classe active sur le nouveau sticky CTA si besoin
            if (wasStickyCTA && wasStickyActive) {
                const newSticky = document.querySelector(`.mm-reload[data-mm-reload-key="${reloadKey}"]`);
                if (newSticky && newSticky.matches('[data-sticky-cta]')) {
                    newSticky.classList.add('active');
                }
            }
        });

        if (keepSubscription !== null) {
            const wantedOption = keepSubscription ? 'abonnement' : 'once';
            document.querySelectorAll('input[name="purchase_option"]').forEach(radio => {
                radio.checked = radio.value === wantedOption;
            });
            if (typeof window.applyPurchaseOptionVariant === 'function') {
                document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(window.applyPurchaseOptionVariant);
            }
        }
        if (typeof window.applyPurchaseOptionMedia === 'function') {
            window.applyPurchaseOptionMedia();
        }

		const newDestinationElements = document.querySelectorAll('.mm-reload');
		newDestinationElements.forEach(dest => {
			const event = new CustomEvent('mm-reload', { detail: { section: dest }, bubbles: true });
			dest.dispatchEvent(event);
		});

        // On réinitialise les scripts nécessaires après le rechargement du DOM
		setTimeout(() => {
			if (typeof initializeSubscription === 'function') {
				initializeSubscription();
			}
			if (typeof handleDropdown === 'function') {
				handleDropdown();
			}
			if (typeof mmSetupProductForm === 'function') {
				mmSetupProductForm();
			}
		}, 100);
    }

    const target = new URL(variantUrl, window.location.origin);

    fetchVariantSections(variantUrl)
        .then(docs => {
            if (window.location.pathname + window.location.search === target.pathname + target.search) {
                updateReloadElements(docs);
            }
        })
        .catch(error => {
            console.error('Erreur fetch variant:', variantUrl, error);
            window.location.href = variantUrl;
        });
}

function initializeVariantSelection() {
    // Utilise la délégation d'événements pour gérer les clics
    document.body.addEventListener('click', function(event) {
        // Gérer les deux types de sélecteurs : principal (.mm-product-form-variants-item) et sticky CTA (.mm-product-variant-selector-item)
        const variantItem = event.target.closest('.mm-product-form-variants-item, .mm-product-variant-selector-item');
        if (variantItem) {
            // Ne pas interférer avec les modales quick add / subscription
            if (variantItem.closest('.mm-product-card-2-add-to-cart')) return;
            handleVariantSelection(variantItem);
        }
    });
}

function preloadVariantImages(docs) {
    // Précharger immédiatement toutes les images de la galerie produit pour ce variant
    try {
        const mainDoc = Object.values(docs).find(doc => doc.querySelector('[data-section-main-product]'));
        const newSection = mainDoc ? mainDoc.querySelector('[data-section-main-product]') : null;
        if (newSection) {
            const imgs = newSection.querySelectorAll('.mm-product-medias-main-splide img, .mm-product-medias-main-splide picture source');
            const imageUrls = new Set();
            
            // Collecter toutes les URLs d'images (img src et picture source srcset)
            imgs.forEach(img => {
                if (img.tagName === 'IMG') {
                    const src = img.currentSrc || img.src || img.getAttribute('src');
                    if (src) imageUrls.add(src);
                } else if (img.tagName === 'SOURCE') {
                    const srcset = img.getAttribute('srcset');
                    if (srcset) {
                        // Parser srcset pour extraire les URLs
                        srcset.split(',').forEach(entry => {
                            const url = entry.trim().split(/\s+/)[0];
                            if (url) imageUrls.add(url);
                        });
                    }
                }
            });
            
            // Précharger toutes les images en parallèle
            imageUrls.forEach(src => {
                const preloadImg = new Image();
                preloadImg.src = src;
            });
        }
    } catch (e) {
        console.error('Erreur preload images variants', e);
    }
}

function preloadVariantPages() {
    // Précharger uniquement les variants du produit de la page (les cartes produit gèrent leurs propres variants)
    const variantItems = Array.from(document.querySelectorAll('.mm-product-form-variants-item, .mm-product-variant-selector-item')).filter(item => !item.closest('.mm-product-card-2-add-to-cart') && !item.classList.contains('active'));
    const variantUrls = [];

    variantItems.forEach(item => {
        const variantUrl = item.getAttribute('data-variant-url');
        if (variantUrl && !variantHtmlCache[variantUrl] && !variantUrls.includes(variantUrl)) {
            variantUrls.push(variantUrl);
        }
    });

    variantUrls.forEach(variantUrl => {
        fetchVariantSections(variantUrl)
            .then(preloadVariantImages)
            .catch(error => {
                console.error('Erreur fetch variant:', variantUrl, error);
            });
    });
}



/*********************************************************************************************
* Initialisation au chargement de la page
*/
// Exposer handleVariantSelection globalement pour être accessible depuis mm-product-variant-card.liquid
window.handleVariantSelection = handleVariantSelection;

document.addEventListener("DOMContentLoaded", () => {
    initializeStickyCTA();
    initializeVariantSelection();
    
    // Démarrer le préchargement des variants et images immédiatement en arrière-plan
    // Utiliser requestIdleCallback pour ne pas bloquer le rendu initial, sinon démarrer après un court délai
    if (window.requestIdleCallback) {
        requestIdleCallback(() => {
            preloadVariantPages();
        }, { timeout: 2000 });
    } else {
        // Fallback pour les navigateurs qui ne supportent pas requestIdleCallback
        setTimeout(() => {
            preloadVariantPages();
        }, 100);
    }

	// Initialisation des sliders au chargement initial
	document.querySelectorAll('.mm-product-medias-main-splide:not([hidden])').forEach(elem => initializeSplideMedia(elem));
	initializeSectionsWithSplide('data-section-main-product', '.mm-product-form-buy-button-infos-reassurance-splide', initializeSplideReassurance);
    
	// Réinitialiser les sliders après rechargement des variants
	document.addEventListener('mm-reload', (e) => {
		if (e.target.matches('.mm-product-medias')) {
			e.target.querySelectorAll('.mm-product-medias-main-splide:not([hidden])').forEach(elem => initializeSplideMedia(elem));
		}
		// Réinitialiser le sticky CTA après rechargement
		if (e.target.matches('[data-sticky-cta]')) {
			initializeStickyCTA();
		}
		// Réinitialiser le splide de réassurance après rechargement de buy-button-infos
		if (e.target.matches('[data-mm-reload-key="buy-button-infos"]')) {
			const splideElem = e.target.querySelector('.mm-product-form-buy-button-infos-reassurance-splide');
			if (splideElem && splideElem.querySelectorAll(".splide__slide").length > 0) {
				initializeSplideReassurance(splideElem);
			}
		}
	});
});

/*********************************************************************************************
* Chat button position sync with Sticky CTA
*/
function updateChatButtonPosition(isStickyActive) {
	const chatButton = document.querySelector('#chat-button');
	if (!chatButton) return;

	if (isStickyActive) {
		const offset = window.innerWidth < 990 ? '250px' : '110px';
		chatButton.style.setProperty('bottom', offset, 'important');
	} else {
		chatButton.style.removeProperty('bottom');
	}
}

/*********************************************************************************************
 * Splide reassurance - Initialisation
 *
 */
function initializeSplideReassurance(splideElem) {
    // Éviter double init (utile quand le DOM est remplacé/injecté, ex: modales)
    if (splideElem && splideElem.splide && typeof splideElem.splide.destroy === 'function') {
        try { splideElem.splide.destroy(); } catch (e) {}
        splideElem.splide = null;
    }

    var splideInstance = new Splide(splideElem, {
        type        : 'loop',
        arrows      : false,
        pagination  : true,
        perPage     : 1,
        drag        : 'free',
        snap        : true,
        fixedWidth  : '100%',
        autoplay    : true,
        interval    : 4000, 
        pauseOnHover: false,
        breakpoints : {
            768: {
            }
        }
    }).mount();

    // Stocker l'instance pour pouvoir destroy/re-init proprement ailleurs
    if (splideElem) {
        splideElem.splide = splideInstance;
    }

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);
}

// Rendre l'init accessible globalement (utilisé par la modale quick add)
window.initializeSplideReassurance = initializeSplideReassurance;
window.initializeSplideMedia = initializeSplideMedia;

/*********************************************************************************************
 * Splide Media - Initialisation
 *
 */
function initializeSplideMedia(splideElem) {
	if (splideElem.splide) {
		splideElem.splide.destroy();
	}
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : true,
        pagination  : false,
        perPage     : 1,
        fixedWidth  : '100%',
    }).mount();

	splideElem.splide = splideInstance;

    // Ajout de l'écouteur d'événement pour le défilement horizontal
    addHorizontalScrollListener(splideElem, splideInstance);

    // Initialisation de la pagination personnalisée
    initializeCustomPagination(splideElem, splideInstance);
}

function initializeCustomPagination(splideElem, splideInstance) {
    const sectionContainer = splideElem.closest('.mm-product-medias-main-splide');
    const paginationContainer = sectionContainer.querySelector('.mm-product-medias-main-pagination');
    
    // Vérifier si la pagination existe (plus d'un slider)
    if (!paginationContainer) {
        return;
    }
    
    const numbers = paginationContainer.querySelectorAll('.mm-product-medias-main-pagination-number');
    
    // Fonction pour mettre à jour l'état actif
    function updateActiveNumber(index) {
        numbers.forEach((number, i) => {
            number.classList.toggle('is-active', i === index);
        });
    }
    
    // Écouter les changements de slide
    splideInstance.on('moved', function(newIndex) {
        updateActiveNumber(newIndex);
    });
    
    // Initialiser le premier number comme actif
    updateActiveNumber(0);
    
    // Ajouter les écouteurs de clic sur les numbers
    numbers.forEach((number, index) => {
        number.addEventListener('click', function() {
            splideInstance.go(index);
        });
    });
}
